import {Component, Inject, OnInit, ViewEncapsulation, ViewContainerRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ApiService} from '../shared/services/api.service';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient} from '@angular/common/http';
import {InternalService} from '../shared/services/internal.service';
import {CookieService} from 'ngx-cookie-service';
import {any} from 'codelyzer/util/function';

@Component({
  selector: 'app-Forbidden',
  templateUrl: './Forbidden.component.html',
  styleUrls: ['./Forbidden.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ForbiddenComponent implements OnInit {


  constructor(private translateModule: TranslateService,
              private router: Router,
              public apiService: ApiService,
              public internalService: InternalService,
              public translate: TranslateService,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {

    if (this.cookieService.get('lang') === undefined) {
      this.cookieService.set('lang', '1');
    }
  }

  ngOnInit() {

  }

  LogOut() {
    this.cookieService.delete('fullName');
    this.cookieService.delete('userId');
    this.cookieService.delete('currentUserRoles');
    this.cookieService.delete('lang');
    this.cookieService.delete('dir');

    const url = this.oidcSecurityService.getEndSessionUrl();
    this.oidcSecurityService.logoffLocal();
    window.location.assign(url);
    this.oidcSecurityService.logoff((url: 'https://mac.medis.land/account/logout') => any);

  }
}

